import STATUS from '../status';
const KB = 1024;
const MB = KB * 1024;

const normalizeFilesize = size => {
  if (size < MB) {
    const num = (size / KB).toFixed(1);
    return `${num}k`;
  }

  const num = (size / MB).toFixed(1);
  return `${num}m`;
};

export default {
  name: 'UploadSection',
  filters: {
    fileSize(size) {
      return normalizeFilesize(size);
    }

  },
  props: {
    status: Number,
    templateLink: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'file'
    },
    accept: {
      type: String,
      default: '.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam,.xls'
    },
    headers: Object,
    data: Object,
    root: Object
  },
  data: () => ({
    currentFile: null,
    uploading: false
  }),
  computed: {
    isInit() {
      return this.status === STATUS.INIT;
    },

    isReady() {
      return this.status === STATUS.UPLOAD_READY;
    },

    success() {
      return this.status === STATUS.UPLOAD_SUCCESS && this.currentFile;
    },

    showFile() {
      return !!this.currentFile;
    },

    showUploadBtn() {
      return this.status <= STATUS.UPLOAD_FAILED;
    },

    failed() {
      return this.status === STATUS.UPLOAD_FAILED;
    },

    btnText() {
      return !this.currentFile ? '开始上传' : '重新上传';
    },

    btnType() {
      return !this.currentFile ? 'primary' : 'text';
    }

  },
  methods: {
    async confirmUpload() {
      this.$refs.upload.submit();
    },

    async handleRequest(req) {
      this.uploading = true;
      this.filename = req.file.name;
      this.filesize = normalizeFilesize(req.file.size);

      try {
        const res = await this.root.$applyPluginsAsyncWaterfall('upload-file', req.file);

        if (res && res.fileToken) {
          this.handleSuccess(res);
        } else {
          this.handleError();
        }
      } catch (e) {
        this.handleError(e);
      }

      this.uploading = false;
    },

    download() {
      return this.root.$applyPluginsAsyncWaterfall('download-template');
    },

    handleChange(file, fileList) {
      this.currentFile = file;

      if (file.status === 'ready') {
        this.$emit('status-change', STATUS.UPLOAD_READY);
      }
    },

    handleSuccess(res) {
      this.$emit('status-change', STATUS.UPLOAD_SUCCESS); // 如果不需要二次确认，直接触发导入操作

      this.$emit('import', res);
    },

    handleError(e) {
      this.$message({
        message: '文件上传失败',
        type: 'error'
      });
      this.$refs.upload.clearFiles();
      this.$emit('status-change', STATUS.UPLOAD_FAILED);
    }

  }
};